import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FileText, Download, ShieldCheck, PenLine, ArrowRight } from "lucide-react";

const TRUST = "https://images.unsplash.com/photo-1681505531034-8d67054e07f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const STEPS = [
  [PenLine, "1. Solicita tu cotización", "Elige el equipo en el catálogo y envía tu solicitud de alquiler o compra."],
  [ShieldCheck, "2. Revisión y aprobación", "Nuestro equipo valida la disponibilidad y condiciones del contrato."],
  [FileText, "3. Contrato generado", "Se genera automáticamente el contrato en PDF con todos los términos."],
  [Download, "4. Descarga y firma", "Descarga tu contrato desde tu panel privado en cualquier momento."],
];

export default function ContractsInfo() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="relative bg-[#0A0A0A] text-white grain overflow-hidden">
        <img src={TRUST} alt="Contratos" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 py-24">
          <div className="overline text-brand mb-3">B2B · Documentación legal</div>
          <h1 className="font-display font-black text-5xl md:text-7xl tracking-tighter leading-[0.9] max-w-3xl">
            CONTRATOS DIGITALES<br /><span className="text-brand">SIN COMPLICACIONES</span>
          </h1>
          <p className="text-white/70 max-w-xl mt-6 text-lg">
            Gestiona contratos de alquiler y compraventa de maquinaria con generación automática de PDF y trazabilidad completa.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 py-20">
        <h2 className="font-display font-black text-4xl tracking-tight mb-12">¿CÓMO FUNCIONA?</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 border-t border-l border-border">
          {STEPS.map(([Icon, t, d]) => (
            <div key={t} className="border-r border-b border-border p-8 hover:bg-brand/5 transition-colors">
              <Icon size={32} className="text-brand mb-4" />
              <div className="font-display font-bold text-xl tracking-tight mb-2">{t}</div>
              <div className="text-sm text-muted-foreground">{d}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-brand text-black">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-display font-black text-4xl tracking-tight">¿LISTO PARA EMPEZAR?</h2>
            <p className="text-black/70">Crea tu cuenta y accede a tu panel de contratos y cotizaciones.</p>
          </div>
          <div className="flex gap-4">
            <Link to="/registro" className="px-8 py-4 bg-black text-white font-semibold hover:bg-black/80 transition-colors flex items-center gap-2">
              Crear cuenta <ArrowRight size={18} />
            </Link>
            <Link to="/catalogo" className="px-8 py-4 border-2 border-black font-semibold hover:bg-black hover:text-white transition-colors">
              Ver catálogo
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
